import React from 'react'
import {Icon} from '@chakra-ui/react'

const ProgressBarIcon = (props) => {
    return (
        <Icon viewBox="0 0 12 12" data-testid="progress-bar-icon" {...props}>
            <g opacity="0.5" clipPath="url(#clip0_5423_4409)">
                <path
                    d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="1 2"
                />
            </g>
            <defs>
                <clipPath id="clip0_5423_4409">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default ProgressBarIcon
